import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  NgZone,
  inject,
  output
} from '@angular/core';
import { Carousel, CarouselStyle } from 'primeng/carousel';
import { PrimeTemplate } from 'primeng/api';
import { NgTemplateOutlet } from '@angular/common';
import { MTooltipComponent } from '../../../components/m-tooltip/m-tooltip.component';
import { MCardComponent } from '../../../components/m-card/m-card.component';
import { MButtonComponent } from '../../../components/m-button/m-button.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-geo-carousel',
  templateUrl: './m-geo-carousel.component.html',
  styleUrls: ['./m-geo-carousel.component.scss'],
  providers: [CarouselStyle],
  imports: [
    Carousel,
    PrimeTemplate,
    MTooltipComponent,
    NgTemplateOutlet,
    MCardComponent,
    MButtonComponent
  ]
})
export class MGeoCarouselComponent extends Carousel {
  constructor() {
    const el = inject(ElementRef);
    const zone = inject(NgZone);

    super(el, zone);
  }

  readonly navigateRequest = output<number>();

  onButtonClick(conversionTypeId: number): void {
    this.navigateRequest.emit(conversionTypeId);
  }

  // PrimeNG 20 applies the root class on the host via `host: { '[class]': "cn(cx('root'), styleClass)" }`.
  // This wrapper extends Carousel but renders its OWN inner <p-carousel>, so that metadata is inherited
  // onto <m-geo-carousel> too — duplicating the carousel root styling on the wrapper host.
  // Neutralize on the wrapper host; the inner carousel is unaffected.
  override cx(): string {
    return '';
  }
}
